/* Product highlights (v4.19.0; assets/product-card.css, snippets/dcp-highlights.liquid, the product page's
   .dmp-hl--pool in sections/product.liquid).

   Turning: a list of highlights is pages laid over each other (two highlights a page on cards, three on the
   product page) with a hidden sizer holding the longest ones, so the block is as tall as its tallest possible
   page from the first paint. Each list on screen shows the next page every 8 seconds on cards and every 10 on
   the product page (Chris, 2026-10-01: 5 was too fast); a list that comes into view keeps its page that long
   first, and one someone points at or has focus in holds still until 2 seconds after they leave. With reduced
   motion the first page stays put. The
   next page of the portal's highlights is dealt from those shown least in this page view, ties broken at
   random and its order shuffled, so any two can show together and none always leads; it is written into one
   of two pages the script adds (copies of the highlights; the page's own stay as the HTML has them, for
   crawlers). A description's own list has no sizer and turns through its pages in order. Lists added later
   (Show more, a homepage row that loads as you scroll) join on the next turn.

   Counting, for the DM Portal (its Portal 25: which highlights get products clicked): on a card whose
   highlights come from the portal (data-pid, each <li data-h> the highlight's id), a highlight on show in view
   for about a second is an impression, and a click on the card counts for the highlights on show then. Each
   counts once per page view. They go in small batches to the portal through the store's app proxy
   (/apps/dm-portal/highlights/events) with navigator.sendBeacon: ids only, no personal data, nothing from
   machines (navigator.webdriver, crawlers' user agents). */
(function () {
  if (window.__dpcTurn) return;
  window.__dpcTurn = true;

  var LISTS = '.dpc .dcp-hl, .dmp-hl--pool';
  var EVERY = { card: 8000, page: 10000 }; // how long a page shows, on cards and on the product page, unless the list says
  var still = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bot = !!navigator.webdriver || /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|preview/i.test(navigator.userAgent || '');

  // A list's pages, its sizer left out.
  function pagesOf(list) {
    var out = [];
    for (var i = 0; i < list.children.length; i++) {
      var c = list.children[i];
      if ((c.classList.contains('dcp-hl__page') || c.classList.contains('dmp-hl__page')) && !c.hasAttribute('data-sizer')) out.push(c);
    }
    return out;
  }
  function shownPage(list) {
    var pages = pagesOf(list);
    for (var i = 0; i < pages.length; i++) if (pages[i].classList.contains('is-on')) return pages[i];
    return pages[0] || null;
  }
  function onScreen(el, w, h) {
    var b = el.getBoundingClientRect();
    return b.width > 0 && b.bottom > 0 && b.top < h && b.right > 0 && b.left < w;
  }
  function held(list) {
    var card = list.closest('.dpc') || list;
    return card.matches(':hover, :focus-within');
  }
  // How long a list shows each page: the DM Portal's setting, which the theme puts on the list as data-every
  // (the shop's metafield custom.dm_highlights_turn), when it is 3 to 30 seconds; else EVERY.
  function everyOf(list) {
    var own = Number(list.getAttribute('data-every'));
    if (own >= 3000 && own <= 30000) return own;
    return list.classList.contains('dmp-hl--pool') ? EVERY.page : EVERY.card;
  }

  // ---------- Turning ----------
  // Only a list with a sizer is dealt (the portal's pools): the sizer holds room for any pairing. A description's
  // own list has none, so it keeps its pages as the HTML has them and turns through them in order.
  function sized(list) {
    for (var i = 0; i < list.children.length; i++) if (list.children[i].hasAttribute('data-sizer')) return true;
    return false;
  }
  // A list's deck, made at its first turn: its highlights as the HTML has them, how often each has been on
  // show, which are on show now, and the two pages the script deals into.
  function deckOf(list) {
    if (list.__dpcDeck) return list.__dpcDeck;
    var pages = pagesOf(list), items = [], seen = [], on = [];
    for (var p = 0; p < pages.length; p++) {
      for (var i = 0; i < pages[p].children.length; i++) {
        if (p === 0) on.push(items.length);
        seen.push(p === 0 ? 1 : 0);
        items.push(pages[p].children[i]);
      }
    }
    var a = pages[0].cloneNode(false), b = pages[0].cloneNode(false);
    a.className = b.className = pages[0].className.replace(/\b(is|was)-on\b/g, '').trim();
    list.appendChild(a);
    list.appendChild(b);
    list.__dpcDeck = { items: items, seen: seen, on: on, size: pages[0].children.length, a: a, b: b };
    return list.__dpcDeck;
  }
  function shuffle(list) {
    for (var j = list.length - 1; j > 0; j--) { var r = Math.floor(Math.random() * (j + 1)), t = list[j]; list[j] = list[r]; list[r] = t; }
    return list;
  }
  // The next page: the highlights shown least (ties at random), those on show now only when too few others
  // are left, in a random order.
  function deal(deck) {
    var off = [], kept = [];
    for (var i = 0; i < deck.items.length; i++) (deck.on.indexOf(i) < 0 ? off : kept).push(i);
    function least(list) { return shuffle(list).sort(function (x, y) { return deck.seen[x] - deck.seen[y]; }); }
    var pick = least(off).slice(0, deck.size);
    if (pick.length < deck.size) pick = pick.concat(least(kept).slice(0, deck.size - pick.length));
    shuffle(pick);
    for (var k = 0; k < pick.length; k++) deck.seen[pick[k]] += 1;
    deck.on = pick;
    return pick;
  }

  if (!still) {
    // Each list keeps its own clock (list.__turnAt): started when it comes on screen, cleared when it leaves.
    setInterval(function () {
      if (document.hidden) return;
      var lists = document.querySelectorAll(LISTS), w = window.innerWidth, h = window.innerHeight, now = Date.now(), turn = [];
      for (var i = 0; i < lists.length; i++) { // read everything first, then write, so the page lays out once
        var l = lists[i], every = everyOf(l);
        if (pagesOf(l).length < 2) continue;
        if (!onScreen(l, w, h)) { l.__turnAt = 0; continue; }
        if (!l.__turnAt) { l.__turnAt = now + every; continue; }
        if (held(l)) { l.__turnAt = Math.max(l.__turnAt, now + 2000); continue; }
        if (now >= l.__turnAt) { turn.push(l); l.__turnAt = now + every; }
      }
      if (!turn.length) return;
      var moves = [];
      for (var j = 0; j < turn.length; j++) {
        var cur = shownPage(turn[j]), next;
        if (sized(turn[j])) {
          // Copies of the dealt highlights, in whichever of the two dealt pages is not on show.
          var deck = deckOf(turn[j]), pick = deal(deck);
          next = cur === deck.a ? deck.b : deck.a;
          next.textContent = '';
          for (var k = 0; k < pick.length; k++) next.appendChild(deck.items[pick[k]].cloneNode(true));
        } else {
          var own = pagesOf(turn[j]);
          next = own[(own.indexOf(cur) + 1) % own.length];
        }
        // The page coming in starts below, wherever it last left.
        next.style.transition = 'none';
        next.classList.remove('was-on', 'is-on');
        moves.push({ list: turn[j], cur: cur, next: next });
      }
      void document.body.offsetHeight; // one layout, so the pages coming in start from below
      for (var m = 0; m < moves.length; m++) {
        var pages = pagesOf(moves[m].list);
        for (var q = 0; q < pages.length; q++) if (pages[q] !== moves[m].cur) pages[q].classList.remove('was-on');
        moves[m].next.style.transition = '';
        moves[m].cur.classList.remove('is-on');
        moves[m].cur.classList.add('was-on');
        moves[m].next.classList.add('is-on');
        moves[m].list.setAttribute('data-on', '');
      }
    }, 1000);
  }

  // ---------- Counting ----------
  if (bot || !navigator.sendBeacon) return;
  var URL_EVENTS = '/apps/dm-portal/highlights/events';
  var streak = {}, seen = {}, clicked = {}, queue = { i: [], c: [] };

  function showing(list) {
    var page = shownPage(list), out = [];
    if (!page) return out;
    var items = page.querySelectorAll('li[data-h]');
    for (var i = 0; i < items.length; i++) if (!items[i].hasAttribute('aria-hidden')) out.push(Number(items[i].getAttribute('data-h')));
    return out;
  }
  function flush() {
    if (!queue.i.length && !queue.c.length) return;
    var body = JSON.stringify(queue);
    queue = { i: [], c: [] };
    try { navigator.sendBeacon(URL_EVENTS, body); } catch (e) { /* a lost count is only a count */ }
  }
  function impression(id) {
    if (seen[id]) return;
    seen[id] = true;
    queue.i.push(id);
  }

  // Each second: a highlight on show on a card in view adds to its streak; two seconds running is an impression.
  setInterval(function () {
    if (document.hidden) return;
    var lists = document.querySelectorAll('.dpc .dcp-hl[data-pid]'), w = window.innerWidth, h = window.innerHeight, now = {};
    for (var i = 0; i < lists.length; i++) {
      if (!onScreen(lists[i], w, h)) continue;
      var ids = showing(lists[i]);
      for (var k = 0; k < ids.length; k++) now[ids[k]] = true;
    }
    for (var id in streak) if (!now[id]) delete streak[id];
    for (var n in now) {
      streak[n] = (streak[n] || 0) + 1;
      if (streak[n] >= 2) impression(Number(n));
    }
    if (queue.i.length >= 24) flush();
  }, 1000);

  // A click on a card counts for the highlights on show, and goes at once (the page is leaving).
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.dpc') : null;
    var list = card ? card.querySelector('.dcp-hl[data-pid]') : null;
    if (!list) return;
    var ids = showing(list);
    for (var i = 0; i < ids.length; i++) {
      impression(ids[i]);
      if (!clicked[ids[i]]) { clicked[ids[i]] = true; queue.c.push(ids[i]); }
    }
    flush();
  }, true);

  setInterval(flush, 15000);
  document.addEventListener('visibilitychange', function () { if (document.hidden) flush(); });
  window.addEventListener('pagehide', flush);
})();
